import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { MemberBaseType } from "../interface";
import { request } from "@/App/api/request";
import { AuthenticationContext, MemberEligibilityContext } from "@/App/context";

export const getEligibilityMemberInformation = async (authToken: string) => {
  return request<{}, MemberBaseType>({
    endpoint: "/eligibility/member/get",
    body: {},
  }, authToken);
};

export const useGetEligibilityMemberInformationQuery = () => {
  const { getAuthToken } = useContext(AuthenticationContext);
  const { memberEligibility } = useContext(MemberEligibilityContext);

  return useQuery({
    queryFn: async () => {
      return getEligibilityMemberInformation(await getAuthToken());
    },
    queryKey: ["eligibilityMemberInformation", memberEligibility.plan.id],
  });
};
